import React from 'react';

function MoveDefault({ fill = '#1D1C1D', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.3335 11.875V10.625H16.6668V11.875H3.3335ZM3.3335 9.375V8.125H16.6668V9.375H3.3335Z" fill={fill} />
    </svg>
  );
}

export default MoveDefault;
